import React, { useEffect, useState } from 'react';
import { Modal, Button, Container, Table } from 'react-bootstrap';
import AddScheduleComp from '../../../../pages/CoachingRequestForm/AddSchedule/AddScheduleComp';
import CoachingServiceRequestForm from './CoachingServiceRequestForm';
import { t } from 'i18next';
import { SessionKeys } from '../../../../utils/AppUtils';
import { useDispatch, useSelector } from 'react-redux';
import { rescheduleSlots, rescheduleSlotsClear } from '../../../../redux/coaching/actions';
import _ from 'lodash';
import Loader from '../../../Loader/Loader';

const Four8HourRescheduleModal = ({ show, setShow, coachId, productTitle, hour, productId ,callFunc}) => {

    const dispatch = useDispatch();
    const today = new Date();
const yyyy = today.getFullYear();
const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
const dd = String(today.getDate()).padStart(2, '0');

const minDate = `${yyyy}-${mm}-${dd}`;
    let rescheduleDetails = useSelector(
        (state) => state.coaching.rescheduleSlotsData
      );

    const [selectedServiceSlot, setSelectedServiceSlot] = useState();

    const [preferredSlotData, setPreferredSlotData] = useState([
        { id: "1", label: "Morning" },
        { id: "2", label: "Afternoon" },
        { id: "3", label: "Evening" },
      ]);
      const [isLoading, setIsLoading] = useState(false);
      const [selectedPreferredSlot, setSelectedPreferredSlot] = useState("");
      const [selectedPreferredDate, setSelectedPreferredDate] = useState("");
      const [errorMsg, setErrorMsg] = useState("");
      const [dateError, setDateError] = useState("");
      const [remarksError, setRemarksError] = useState("");
      const [remarks, setRemarks] = useState("");
      const [serviceSlots, setServiceSlots] = useState([
        { id: "2", price_id: "2", slot_type: "4 Hours" },
        { id: "3", price_id: "3", slot_type: "8 Hours" },
      ]);

    const onsubmit = () => {
        setErrorMsg("");
        setDateError("");
        setRemarksError("");

        if (!selectedPreferredSlot) {
            setErrorMsg(t("Please select preferred slot"));
            return;
        }
        if (!selectedPreferredDate) {
            setDateError(t("Please select preferred date"));
            return;
        }
        if (!remarks) {
            setRemarksError(t("Please add remarks"));
            return;
        }

        // if (remarks?.length < 10) {
        //     setRemarksError(t("Remarks should be at least 10 characters"));
        //     return;
        // }


    const data = {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        request_to: coachId,
        entity_id: productId,
        request_type: "slot_reschedule",
        hour: hour,
        remark: remarks,
        preferred_date: selectedPreferredDate,
        preferred_time: selectedPreferredSlot.toLowerCase(),
    };

    setIsLoading(true);
    dispatch(
            rescheduleSlots({
              module: "rescheduleSlot",
              postData: data,
            })
          );
    }
    

    useEffect(() => {
        console.log("rescheduleDetails", rescheduleDetails);
    
        if (!_.isEmpty(rescheduleDetails)) {
            setIsLoading(false);
          if (rescheduleDetails?.status === "success") {
            const rescheduleArr = rescheduleDetails?.payload?.payload;
            console.log("rescheduleArr1", rescheduleArr);
            dispatch(rescheduleSlotsClear());
            callFunc();
          }
        }
      }, [rescheduleDetails]);

    return (
        <Modal
            show={show}
            onHide={() => { setShow(false) }}
            backdrop="static"
            keyboard={false}
            className="custom-modal"
            size="md"
            centered
        >
            <Modal.Header closeButton className="border-0"></Modal.Header>
            <Modal.Body >

                {<>
                    <Loader start={isLoading} />
                    <Container>
                    <div className="container-slot w-100 mt-3">
                    <div class="sep"></div>
                    {false && <div className="pb-3 d-flex justify-content-between">
                      <div className="d-flex align-items-center gap-4">
                        <div className="mentor-title mb-0">{t("Request your slot")}</div>
                      </div>
                      {serviceSlots?.length > 1 && (
                        <div className="ms-auto">
                          <select
                            className="form-select input_searchfield ps-3 p-2 pe-5 rounded-pill"
                            onChange={(ev) => setSelectedServiceSlot(ev.target.value)}
                            value={selectedServiceSlot}
                          >
                            {serviceSlots.map((ex, index) => {
                              return (
                                <option
                                  value={ex?.price_id}
                                  selected={
                                    selectedServiceSlot === ex?.price_id ? true : false
                                  }
                                  key={index}
                                >
                                  {ex?.slot_type}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      )}
                    </div>}
                    <div className="slotparent">
                      <div className="row">
                        <div className="col">
                          <div className="input-text position-relative disable_field">
                            <label htmlFor="manager" className="input__label">
                              {t("Preferred Date")}
                              {"*"}
                            </label>
                            <input
                              className=" input_searchfield"
                              type="date"
                              id="dateField"
                              name="dateField"
                              min={minDate}
                              onChange={(e) => setSelectedPreferredDate(e.target.value)}
                              value={selectedPreferredDate}
                            />
                          </div>
                          {dateError && <p className="error-msg">{dateError}</p>}
                        </div>
                        <div className="col">
                          <div className="input-text position-relative disable_field">
                            <label htmlFor="manager" className="input__label">
                              {t("Preferred Slot")}
                              {"*"}
                            </label>
                            <select
                              className="form-select input_searchfield"
                              id="category"
                              aria-label="Default select example"
                              onChange={(event) =>
                                setSelectedPreferredSlot(event.target.value)
                              }
                              required
                            >
                              <option value="">Select preferred slot</option>
                              {preferredSlotData?.map((slot, index) => {
                                return (
                                  <option
                                    value={slot.label}
                                    selected={slot?.label === selectedPreferredSlot}
                                    key={index}
                                  >
                                    {slot.label}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          {errorMsg && <p className="error-msg">{errorMsg}</p>}
                        </div>
              
                        <div className="input-text position-relative disable_field">
                          <label htmlFor="manager" className="input__label">
                            {t("Additional Remarks")}
                            {"*"}
                          </label>
                          <textarea
                            type="text"
                            rows={3}
                            placeholder="Please add message"
                            className="input__field"
                            onChange={(e) => setRemarks(e.target.value)}
                            required
                          />
                          {remarksError && <p className="error-msg">{remarksError}</p>}
                        </div>
                      </div>
                    </div>
                    <div id="checkout-button"></div>
                    <div className="sep"></div>
                    <div className="d-flex footer-btn-card justify-content-between align-items-center gap-1">
                      
                      <div className="d-flex gap-3">
                        <Button
                          className="btn btn-secondary"
                          onClick={() => {
                            setShow(false);
                          }}
                        >
                          {t("Cancel")}
                        </Button>
                        <Button
                          className="btn btn-primary"
                          onClick={() => {
                            onsubmit();
                          }}
                        >
                          {t("Reschedule")}
                        </Button>
                      </div>
                    </div>
                  </div>

                    </Container>
                </>
                }
            </Modal.Body>
        </Modal>
    );
};

export default Four8HourRescheduleModal;